import { api } from "./api"

export const EMIT_AGENDA_REPORTS = async (format: 'pdf', params: any) => {
    const {data} = await api.post(`/reports/emit/agenda/${format}`, params)
    return data;
}

export const GET_REPORT = async (type, companyId: string, params: any) => {
    const {data} = await api.get(`/reports/${type}/${companyId}`, { params })
    return data;
}

export const DOWNLOAD_REPORT = async (type, companyId: string, format: string, params: any) => {
    const {data} = await api.get(`/reports/download/${type}/${companyId}/${format}`, { params })
    return data;
}

export const GET_TEMPLATES = async (format, companyId: string) => {
    const {data} = await api.get(`/reports/get/templates/${format}/${companyId}`)
    return data;
}
